import React from 'react';
import Layout from './Layout';

function ShellPage({ component: Component, user, onLogout, ...props }) {
  return <Layout user={user} onLogout={onLogout}><Component {...props} /></Layout>;
}

export default ShellPage;
